var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrderResume',{attrs:{"order":_vm.order,"solution":"retail"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }